import { useCallback } from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { addDays, format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

import { changeSelectedDayOfNextDay, loadWithQuickFilter } from 'features/views/marketPlace/actions';
import { quickFilter } from 'features/views/marketPlace/constants';
import { getSelectedDayOfNextDays } from 'features/views/marketPlace/selectors';

export const NextSevenDaysPills = () => {
	const dispatch = useDispatch();
	const selectedNextDay = useSelector(getSelectedDayOfNextDays);

	const handleNextDaysChange = useCallback(
		(nextDayDate) => () => {
			dispatch(changeSelectedDayOfNextDay(nextDayDate));
			dispatch(loadWithQuickFilter(quickFilter.FUTURE));
		},
		[dispatch],
	);

	const generateDays = () => {
		const arr = [];

		for (let index = 1; index < 8; index++) {
			const nextDay = format(addDays(new Date(), index), 'yyyy-MM-dd');
			arr.push(nextDay);
		}

		return arr;
	};

	const days = generateDays();

	return (
		<Stack direction="row" spacing={1}>
			{days.map((day, id) => (
				<Chip
					key={id}
					size="small"
					label={format(new Date(days[id]), 'dd.MM.yyyy')}
					color={days[id] === selectedNextDay ? 'primary' : 'default'}
					onClick={handleNextDaysChange(days[id])}
				/>
			))}
		</Stack>
	);
};

export default NextSevenDaysPills;
